import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as DeviceDataActions from '../_actions/deviceData';
import { DeviceData } from '../_models';

export interface DeviceDataState extends EntityState<DeviceData> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<DeviceData> = createEntityAdapter<DeviceData>();

const initialState: DeviceDataState = adapter.getInitialState({
  loading: false,
  error: null,
});

const deviceDataReducer = createReducer(
  initialState,

  on(DeviceDataActions.loadDevicesData, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(DeviceDataActions.loadDevicesDataSuccess, (state, { devicesData }) =>
    adapter.setAll(devicesData, { ...state, loading: false })
  ),

  on(DeviceDataActions.loadDevicesDataFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);

export function reducer(state: DeviceDataState | undefined, action: Action) {
  return deviceDataReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
